import { render } from "./CobaltProfile.vue?vue&type=template&id=12e6eb10"
import script from "./CobaltProfile.vue?vue&type=script&lang=js"
export * from "./CobaltProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__